/*
 * FeedAnswers Module
 *
 * Description:
 * This modules handles all events related to feed answers and also validates answer form submission
 *
 * Purpose: 
 * This module is necessary to divide feed module into smaller components
 * 
 * Inputs
 * 
 * Outputs
 *
 * @authors: Chiran Doshi and Elton Jain
 */

define('FeedAnswers',[
	'jquery',
	'Auth',
	'Validation',
	'JSTemplate',
	'UI',
	'modules/common/Constants',
	'Config',
	'Helper',
	'cookie'
], function($, Auth, Validation, template, UI, Constants, Config, Helper) {
	'use strict';

	var langs = Config.get('lang'),
		answerValidationRules = {
			message: {
				presence: {
					message: '^' + langs.err_a_blank
				}
			}
		},

		postUserId,

		commentValidationRules = {
			message: {
				presence: {
					message: '^' + langs.err_c_blank
				}
			}
		},

		o,
		defaults = {
			feedContainerId: 'feed',
			apiLike: '/ajax/answer/like',
			apiUnlike: '/ajax/answer/unlike',
			apiAnswer: '/ajax/answers',
			txtAnswerInputClass: '.inp-answer-text',
			txtCommentInputClass: '.inp-comment-text',
			eleAnswerFormClass: '.form-post-answer',
			eleCommentFormClass: '.form-post-comment',
			eleAnswerAttachClass: '.cnt-attachments',
			eleAnswerFileSelectClass: '.inp-file-select',
		},
		$elFeedContainerId,
		objImageForm = {},
		_updateLikeCount = null,
		userData = Auth.getUser(),

		setLikeCountFunction = function(likeFunction) {
			_updateLikeCount = likeFunction;
		},

		_likeAnswer = function(answerId, doLike, $btn, questionId) {
			var api = (doLike === false) ? o.apiUnlike : o.apiLike,
				mixpanelData = {};
				// $eleLikeCount = $btn.find('.lbl-like-count');

			if (!Auth.checkLoginRequired({source: 'feed answer like'})) {
				return false;
			}

			mixpanelData = {
				'question_id': questionId,
				'reply_id': answerId,
				// 'question_text' : data.question_text,
				'user': userData.fullname,
				'user_id': userData.id
			};


			$.post(api, {
				answerId: answerId
			}, function(response) {

				if (response.status === true) {

					// Update Like count
					// var $eleLikeCount = $btn.find('.lbl-like-count');

					if (doLike === true) {
						require(['Mixpanel'], function(MixPanel) {
							MixPanel.hit('answer_like', mixpanelData);
						});
					}

				} else if (response.status === false) {
					// Decrease Like count

					if (response.status_code === Constants.status_code.no_auth_login) {
						// Show login popup
						Auth.showLoginPopup(true, {source: 'feed answer like'});
						//alert('You need to login (login popup)');
					} else if (response.status_code === Constants.status_code.no_auth_group) {
						alert('You need to join the group to like like this answer');
					} else {
						alert(response.message);
					}

				}
			});
		},

		_loadMoreAnswers = function(options) {
			// Options = (page, empty feed/reset, type, groupId )

			$.post(o.apiAnswer, {
				page: options.page,
				questionId: options.questionId,
			}, function(response) {
				if (options.callback) {
					options.callback(response);
				}
			}).fail( function(xhr, textStatus, errorThrown) {
				require(['Toastr'], function (Toastr) {
					new Toastr({
                        'message': xhr.responseText
                    });
				});
		    });

		},

		_showAccountSelectDialog = function(accounts) {
			var html = template('tplSelectUserContainer');
			$('body').append(html);

			require(['DataList','History'], function(DataList, History) {
				var dataList1 = new DataList();

                dataList1.init({
                    containerId: 'userSelectList',
                    template: 'tplSelectUserList',
                    useApi: false,
                    data: accounts,
                    autoload: false,
                    searchable: false,
                    selectable: true
                });

                History.pushState({
	                url: window.location.href,
	                popupId: 'userPostSelect'
	            });

			});
		},

		_getFeedAnswerRender = function(answerData, options) {
			var answerTemplate = 'tplAnswerList',
				defaults = {
					User: Auth.getUser(),
					isDetailPage: true,
					isNewAnswer: false,
					page: 1,
					questionId: null
				},
				o = $.extend(defaults, options),
				tmplData = {};

			// Data format
			// {topics: array(), isGroupPage: false, isDetailPage: false}
			tmplData = {
				User: o.User,
				answers: answerData,
				isDetailPage: o.isDetailPage,
				isNewAnswer: o.isNewAnswer,
				page: o.page,
				questionId: o.questionId,
	            modules: {
	            	Helper: Helper,
	            	Config: Config
	            }
			};
			return template(answerTemplate, tmplData);
		},

		_bindEvents = function() {

			UI.$b.on('click','.user-select', function() {
				postUserId = $(this).data('id');
		
				 if($('.app-page-answer').length > 0) {
				 	$('.app-page-answer ' + o.eleAnswerFormClass).submit();
				 } else {
				 	$(o.eleAnswerFormClass).submit();
				 }
				 $("#userPostSelect").trigger("click");
				 return false;
			});

			UI.$b.on('click', '.feed-post .btn-answer-like', function(e) {
				e.preventDefault();
				if (!Auth.checkLoginRequired({source: 'feed answer like'})) {
					return false;
				}
				var $btn = $(this),
					$elCounter = $btn.children('.itm-action-count'),
					answerId = $btn.data('ans'),
					isLiked = $btn.is('.active') ? true : false,
					mixpanelData = {},
					count = parseInt($elCounter.text()) || 0,
					questionId = $btn.parents('.feed-post').data('id');

					if($(e.target).hasClass('itm-action-count')) {
						return;
					}

					// answerId = $btn.data('ans'),
					// questionId = $btn.parents('.feed-post').data('id'),
					// $parent = $btn.parents('.post-actions'),
					// $likesWrap = $parent.find('.post-itm-likes-count'),
					// $elCounter = $likesWrap.find('.lbl-like-count'),
					// count = parseInt($elCounter.text()),
					// isLiked = $btn.is('.active') ? true : false;

				if(isLiked) {
					// Unlike
					$elCounter.text(--count);
					$btn.removeClass('active');
					if(!count >= 1) {
						$elCounter.addClass('hidden');
					}

				} else {
					// Like
					$elCounter.text(++count);
					if(count >= 1) {
						$elCounter.removeClass('hidden');
					}
					$btn.addClass('active');
				}

				// _updateLikeCount($btn, isLiked);

				_likeAnswer(answerId, !isLiked, $btn, questionId);

				return false;
			});

			UI.$b.on('click','.load-more-comments',function(e){

				if (!Auth.checkLoginRequired({source: 'feed comments lazyload'})) {
					return false;
				}
				e.preventDefault();

				var that = $(this),
					data = {
						page: that.data('page'),
						replyId: that.data('reply-id'),
						lastCommentId: that.siblings().first().data('id')
					},
					containerId = "#comment-list-" + data.replyId,
					$container = $(containerId);

				$container.addClass('loading');

				$.post('/ajax/answer/comments',data,function(response) {

					$(containerId + ' .load-more-comments').remove();

					$container.removeClass('loading');

					if(response.status == true) {

						var html = template('tplCommentList',{
							response: response.response,
							replyId: data.replyId,
							page: data.page,
							modules: {
								Helper: Helper
							}
						});

						$(containerId +  ' .post-comments').prepend(html);
					}
				});

				return false;
			});

			UI.$b.on('click','.btn-a-comment',function(e){
				if (!Auth.checkLoginRequired({source: 'feed comment btn'})) {
					return false;
				}
				var replyId = $(this).data('reply-id'),
					$elCommentList = $('#comment-list-' + replyId),
					$txtComment = $elCommentList.find(o.txtCommentInputClass),
					scrollTo;

				$elCommentList.find('form').removeClass('hidden');

				$(this).addClass('hidden');

				$txtComment.focus();

				scrollTo = $txtComment.offset().top;
				if(scrollTo > 150) {
					scrollTo -= 150;
					$('html, body').animate({
				 		scrollTop: scrollTo
				 	}, 500);
				}
			});

			UI.$b.on('click', '.feed-post .btn-answer-comment', function(e) {

				if (!Auth.checkLoginRequired({source: 'feed comment btn'})) {
					return false;
				}

				var $btn = $(this),
					reply = $btn.parents('li'),
					data = {
						replyId: reply.data('id'),
						langs: Config.get('lang')
					},
					$elCommentList = $('#comment-list-' + data.replyId),
					$txtComment = $elCommentList.find(o.txtCommentInputClass),
					scrollTo;

				if(!$elCommentList.length) {
					$elCommentList = $(template('tplCommentBlock',data));
					$btn.parents('li.ans-item').append($elCommentList);

				} else {
					$elCommentList.find('form').removeClass('hidden')
				}

				$txtComment = $elCommentList.find(o.txtCommentInputClass);

				$txtComment.focus();
				scrollTo = $txtComment.offset().top;
				if(scrollTo > 150) {
					scrollTo -= 150;
					$('html, body').animate({
				 		scrollTop: scrollTo
				 	}, 500);
				}	

				 
				$elCommentList.find('.btn-a-comment').addClass('hidden');
			});

			UI.$b.on('focus click', o.txtCommentInputClass, function() {
				if($(o.eleAnswerFormClass).hasClass('static')) {
					$(o.eleAnswerFormClass).addClass('hidden');	
				}
			});

			UI.$b.on('focusout', o.txtCommentInputClass, function() {
				if($(o.eleAnswerFormClass).hasClass('static')) {
					$(o.eleAnswerFormClass).removeClass('hidden');
				}
			});

			UI.$b.on('focus click', o.txtAnswerInputClass, function() {
				
				var $answerForm = $(this).parents(o.eleAnswerFormClass);
				$answerForm.addClass('open');
			}).on('blur', o.txtAnswerInputClass, function () {
				var $answerForm = $(this).parents(o.eleAnswerFormClass),
					$answerFormWrap = $answerForm.parents('.form-post-answer-wrap');
				if($answerFormWrap.length) {
					$answerFormWrap.height($answerForm.outerHeight());
				}
			});

			// if ($(o.eleAnswerFormClass).length) {
			if (/^(group|group.tv_episode|home|topic|unanswered|questionfollow|poll)$/.test(Config.get('page.route'))) {
				// Submitting Answer form
				UI.$b.on('submit', o.eleAnswerFormClass, function() {

	                var $form = $(this),
	                    images = objImageForm ? objImageForm.getImages() : null,
	                    formData = $.extend($form.serializeArray(), {}),
	                    _fd = new FormData(),

	                    validation = new Validation({
			                form: $form,
			                allConstraints: answerValidationRules
			            });


	                if (validation.isValid() !== true) {
	                    return;
	                }

	                $.each(images, function(i, file) {
	                    _fd.append('image' + i, file);
	                });

	                $.each(formData, function(i, input) {
	                    _fd.append(input.name, input.value);
	                });

	                if(!Auth.checkLoginRequired({source: 'feed answer form'})) {
	                	var that = this;
	                	require(['Mixpanel'], function(MixPanel) {
	                        MixPanel.hit('click', {
                                target: 'post answer logged out',
                                target_id: that.questionId.value,
                                message: that.message.value
                            });
	                    });
	                	$.cookie('question_answer',{
	                		questionId:this.questionId.value,
	                		message:this.message.value
	                	});
						return false;
					}

	                $form.addClass('loading');

	                var userData = Auth.getUser();

	                if(userData.is_admin && window._gtap.data.other_accounts && window._gtap.data.other_accounts.length > 0) {
	                	if(postUserId) {
	                		_fd.append('userId',postUserId);
	                	} else {
	                		$form.removeClass('loading');
	                		_showAccountSelectDialog(window._gtap.data.other_accounts);
	                		return false;
	                	}
	                }


	                // Ajax call to save the answer
	                $.ajax({
	                    url: '/ajax/question/answer',
	                    data: _fd,
	                    processData: false,
	                    contentType: false,
	                    type: 'POST',
	                    success: function(response) {
	                        _fd = null;
	                        $form.removeClass('loading');

	                        if (response.status === true) {
	                        	postUserId = '';
			                    // Render and add to the #Feed                                    
			                    var html = _getFeedAnswerRender(response.response, {
			                            isDetailPage: true,
			                            isNewAnswer: true
			                        }),
			                    	$html = $(html),
			                        replyData = response.response.replies,
			                        questionId = replyData[0].topic_id,
			                        $eleAnswersContainer = $('#feed-answers-' + questionId),
			                        mixpanelData = {};

			                    if (!$form.is('.static')) {
			                        $form.addClass('hidden');
			                    }

			                    if((Auth.getUser().is_verified || Auth.getUser().admin_role !== null) && !$form.is('.static')) {
			                    	if($('#main-feed-answers-' + questionId).length == 0) {
			                    		html = '<ul class="post-answers" id="main-feed-answers-' + questionId + '">' + html + '</ul>';
			                    		$form.after(html);	
			                    	} else {
			                    		$('#main-feed-answers-' + questionId).append(html);
			                    	}
			                    	
			                    } else {
			                    	$eleAnswersContainer.prepend($html);	
			                    	if ($('#answer-' + response.response.replies[0].id).length) {
				                    	var $viewport = $('#app-page-answer').length ? $('#app-page-answer') : UI.$b,
				                    		$elNewAnswer = $('#answer-' + response.response.replies[0].id);
				                        $viewport.animate({
				                            scrollTop: $elNewAnswer.offset().top - 200
				                        }, 1000);
			                    	}
			                    }
			                    
			                    $form.removeClass('open');
			                    
			                    Helper.linkifyFeedContent($html.find('.cmt-text'));

			                    mixpanelData = {
			                        question_id: replyData[0].topic_id,
			                        reply_id: replyData[0].id,
			                        user: userData.fullname,
			                        user_id: userData.id
			                    };

			                    require(['Mixpanel'], function(MixPanel) {
			                        MixPanel.hit('answer_create', mixpanelData);
			                    });

			                    // Reset form
			                    _closeAnswerForm($form);

			                    // Hide message if exists
			                    if ($('.post-answer-ribbon').length > 0) {
			                        $('.post-answer-ribbon').remove();
			                    }
			                } else {
			                    alert(response.message);
			                }
	                    }
	                });

	                return false;
	            });

	            // Code to be executed on submitting comment
	            UI.$b.on('submit', o.eleCommentFormClass, function() {

                    var $form = $(this),
                    	validation = new Validation({
			                form: $form,
			                allConstraints: commentValidationRules
		            	}),
		            	formData = $.extend($form.serializeArray(), {}),
		            	 _fd = {};

		            if (validation.isValid() !== true) {
	                    return;
	                }

	                $.each(formData, function(i, input) {
	                    _fd[input.name] =  input.value;
	                });

	                $form.addClass('loading');

	                // Post Comment
	                $.post('/ajax/answer/comment/save',_fd,function(response){
	                	$form.removeClass('loading');

	                	if(response.status == true) {

	                		var comment = response.response.comments[0],
	                			$elCommentList = $('#comment-list-' + comment.reply_id),
	                			mixpanelData = {
	                				reply_id: comment.reply_id,
	                				comment_id: comment.id,
	                				user_id: comment.user_id,
	                				user: comment.user.fullname,
	                				comment_text: comment.message
	                			};


	                		$form.addClass('hidden');

	                		$form[0].reset();

	                		response.response.more_comment_count = 0;
	                		
	                		var $html = $(template('tplCommentList',{
								response: response.response,
								replyId: comment.reply_id,
								page: 0,
								modules: {
									Helper: Helper
								}
							}));


							$elCommentList.find('.btn-a-comment').removeClass('hidden').attr('data-reply-id',comment.reply_id);
							$elCommentList.find('.post-comments').append($html);

							Helper.linkifyFeedContent($html.find('.cmt-text'));

							require(['Mixpanel'],function(MixPanel) {
								 MixPanel.hit('comment_create', mixpanelData);
							});
	                	}

	                });

	            });

				// Initializing Image upload for Answer form

				require(['ImageForm'], function (ImageForm) {
					objImageForm = new ImageForm({
	                    elForm: o.eleAnswerFormClass,
	                    elFileSelect: o.eleAnswerFileSelectClass,
	                    elSelectTrigger: '.btn-attach-image',
	                    elPreviewContainer: o.eleAnswerAttachClass,
	                    maxImages: 1,
	                    onChange: function() {
	                        var imgCount = this.hasImages();
	                        // console.log(imgCount);
	                        if (imgCount >= 1) {

	                        }
	                    }
	                });
				});
			}

			// Feed Lazy Loading
			if (/home|group|poll|topic|unanswered/.test(Config.get('page.route'))) {
				// UI.$b.on('click', '.feed-post .load-more-answers', function(e) {
				UI.$b.on('click', '.feed-post .btn-more-answers', function(e) {
					if(Helper.Url.hasParam('replyId')) {
						return true;
					}
					if (!Config.get('page.isQuestionDetailPage') && !window._gtap.settings.page.isDetailPage) {
						return false;
					}

					if(!Auth.getUser()) {
						$.cookie('loginPopup',true,{expires:1});
						return true;
					}

					e.preventDefault();

					var $btn = $(this),
						questionId = $btn.data('q') ? $btn.data('q') : null,
						page = $btn.data('page');
					
					$btn.addClass('loading');


					_loadMoreAnswers({
						page: page,
						questionId: questionId,
						callback: function(response) {
							// var response = this;
							$btn.removeClass('loading');
							if (response.status === true && response.response) {
								var $renderedHtml = $(_getFeedAnswerRender(response.response, {
									page: page,
									questionId: questionId
								}));
								$btn.replaceWith($renderedHtml);
								Helper.linkifyFeedContent($renderedHtml.find('.cmt-text'));

								// $('#feed-comments-' + o.questionId).append(renderedHtml);
							} else {
								if (response.status_code === Constants.status_code.no_auth_login) {
									Auth.showLoginPopup(true, {source: 'feed answer lazyload'});
								} else if (response.status_code == Constants.status_code.no_auth_group && response.response) {
									var grp = response.response.group_info || {};

									require(['Groups'], function(Groups) {
										Groups.showJoinGroupPopup({
											image: grp.image,
											id: grp.id,
											name: grp.name,
											url: grp.url
										});
									});

								} else {
									alert(response.message);
								}
							}

						}
					});

					e.stopImmediatePropagation();
					return false;
				});
			}
		},

		_resetAnswerForm = function($formEle) {
			var base = this;
			$formEle[0].reset();
			$formEle.find(o.eleAnswerAttachClass).html('');
			if(objImageForm) {
				objImageForm.reset();
			}
		},

		_closeAnswerForm = function ($formEle) {
			_resetAnswerForm($formEle);
			$formEle.find(o.txtAnswerInputClass).height('auto');
			$formEle.parents('.form-post-answer-wrap').height('auto');
			$formEle.removeClass('open');
		},

		init = function(options) {
			o = $.extend(defaults, options);
			$elFeedContainerId = $('#' + o.feedContainerId);
			$.cookie.json = true;

			if($.cookie('question_answer')) {
				var question_answer = $.cookie('question_answer');
				if(window._gtap.data && window._gtap.data.questionData && window._gtap.data.questionData.topic && window._gtap.data.questionData.topic.id == question_answer.questionId) {
					$(o.eleAnswerFormClass).find(o.txtAnswerInputClass).val(question_answer.message);
					$.removeCookie('question_answer');
				}
			}

			_bindEvents();
		};

	return {
		init: init,
		setLikeCountFunction: setLikeCountFunction,
		getAnswers: _loadMoreAnswers
	};

});
